import type { TranslationDictionary } from "../types";

export const en: TranslationDictionary = {
  "menu.section.dashboard": "Dashboard",
  "menu.section.hr": "HR",
  "menu.section.workforce": "Employees & Organization",
  "menu.section.attendance": "Attendance",
  "menu.section.manager": "My team",
  "menu.section.payroll": "Payroll",
  "menu.section.recruitment": "Recruitment",
  "menu.section.assets": "Assets",
  "menu.section.security": "Security",
  "menu.section.itsm": "ITSM",
  "menu.section.msp": "MSP Operations",
  "menu.section.contracts": "MSP Commercial",
  "menu.section.serviceDelivery": "Service Delivery",
  "menu.section.crm": "CRM",
  "menu.section.support": "Support",
  "menu.section.administration": "Administration",
  "menu.section.tenants": "Tenants",
  "menu.section.platform": "Platform",
  "menu.section.languages": "Languages",
  "menu.item.dashboard": "Dashboard",
  "menu.item.tenantDashboard": "ITaaS Dashboard",
  "menu.item.workforceHome": "Workforce home",
  "menu.item.recruitmentHome": "Recruitment home",
  "menu.item.attendanceHome": "Attendance home",
  "menu.item.employees": "Employees",
  "menu.item.departments": "Departments",
  "menu.item.positions": "Positions",
  "menu.item.organization": "Organization",
  "menu.item.organizationChart": "Org chart",
  "menu.item.organizationDepartments": "Departments",
  "menu.item.organizationPositions": "Positions",
  "menu.item.organizationManagers": "Managers",
  "menu.item.actionValidationInbox": "Validations",
  "menu.item.actionValidationPolicies": "Validation policies",
  "menu.item.leavesSection": "Leave",
  "menu.item.leaveRequests": "Requests",
  "menu.item.leaveBalances": "Balances",
  "menu.item.leaveCalendar": "Calendar",
  "menu.item.leaveApprovals": "Approvals",
  "menu.item.attendance": "Attendance",
  "menu.item.attendanceSection": "Attendance",
  "menu.item.attendanceRecords": "Records",
  "menu.item.attendanceCalendar": "Calendar",
  "menu.item.attendanceExceptions": "Exceptions",
  "menu.item.attendanceAnalytics": "Analytics",
  "menu.item.attendanceDiscrepancies": "Discrepancies",
  "menu.item.attendanceBiometricDevices": "Biometric readers",
  "menu.item.scheduleSection": "Schedules & Shifts",
  "menu.item.schedules": "Schedules",
  "menu.item.shifts": "Shifts",
  "menu.item.assignments": "Assignments",
  "menu.item.rotations": "Rotations",
  "menu.item.performanceSection": "Performance",
  "menu.item.performanceGoals": "Goals",
  "menu.item.performanceKPIs": "KPIs",
  "menu.item.performanceReviews": "Reviews",
  "menu.item.performanceScores": "Scores",
  "menu.item.performanceSuggestions": "Suggestions",
  "menu.item.compensationSection": "Compensation",
  "menu.item.compensationDashboard": "Overview",
  "menu.item.compensationBonuses": "Bonuses",
  "menu.item.compensationAdjustments": "Adjustments",
  "menu.item.compensationRules": "Rules",
  "menu.item.trainingSection": "Training & Learning",
  "menu.item.trainingDashboard": "Overview",
  "menu.item.trainingCourses": "Courses",
  "menu.item.trainingAssignments": "Assignments",
  "menu.item.trainingCertifications": "Certifications",
  "menu.item.careerSection": "Career & Succession",
  "menu.item.careerDashboard": "Overview",
  "menu.item.careerPaths": "Career Paths",
  "menu.item.careerPromotions": "Promotion Readiness",
  "menu.item.careerSuccession": "Succession Plans",
  "menu.item.careerGoals": "Career Goals",
  "menu.item.recruitmentSection": "Recruitment",
  "menu.item.recruitmentDashboard": "Overview",
  "menu.item.recruitmentJobs": "Jobs",
  "menu.item.recruitmentCandidates": "Candidates",
  "menu.item.recruitmentInterviews": "Interviews",
  "menu.item.recruitmentPipeline": "Pipeline",
  "menu.item.recruitmentTalentPool": "Talent pool",
  "menu.item.recruitmentEmailImport": "Email import",
  "menu.item.assetsSection": "Assets",
  "menu.item.assetsDashboard": "Overview",
  "menu.item.assetsInventory": "Inventory",
  "menu.item.assetsAssignments": "Assignments",
  "menu.item.assetsMaintenance": "Maintenance",
  "menu.item.assetsLifecycle": "Lifecycle",
  "menu.section.inventory": "Inventory",
  "menu.section.inventoryOverview": "Overview",
  "menu.section.inventoryOrganization": "Organization",
  "menu.section.inventoryCatalog": "Catalog",
  "menu.section.inventoryLogistics": "Logistics",
  "menu.section.inventoryStock": "Stock & movements",
  "menu.section.inventoryIntegrations": "Integrations",
  "menu.section.inventoryAdmin": "Administration",
  "menu.item.inventoryDashboard": "Dashboard",
  "menu.item.inventoryArticles": "Articles",
  "menu.item.inventoryOrganization": "Organization",
  "menu.item.inventoryCategories": "Categories",
  "menu.item.inventoryBrands": "Brands",
  "menu.item.inventoryUnits": "Units",
  "menu.item.inventoryWarehouses": "Warehouses",
  "menu.item.inventoryLocations": "Zones & locations",
  "menu.item.inventoryStockBalance": "Stock levels",
  "menu.item.inventoryMovements": "Movement ledger",
  "menu.item.inventoryReceipts": "Receipts",
  "menu.item.inventoryIssues": "Issues",
  "menu.item.inventoryTransfers": "Transfers",
  "menu.item.inventoryAdjustments": "Adjustments",
  "menu.item.inventoryReturns": "Returns",
  "menu.item.inventoryReconciliation": "Reconciliation",
  "menu.item.inventoryWebhooks": "Webhooks",
  "menu.item.inventoryBarcode": "Scan & barcodes",
  "menu.item.inventoryStockLabels": "Stock label printing",
  "menu.item.inventoryDevices": "Readers & terminals",
  "menu.item.inventoryLabelPrinting": "Label printing",
  "menu.item.inventoryAudit": "Audit log",
  "menu.item.inventoryNotifications": "Notifications",
  "menu.item.inventorySettings": "Settings",
  "menu.section.product": "Product Catalog",
  "menu.item.productDashboard": "Dashboard",
  "menu.item.productProducts": "Products",
  "menu.item.productCategories": "Categories",
  "menu.item.productBrands": "Brands",
  "menu.item.productUnits": "Units",
  "menu.item.productTags": "Tags",
  "menu.section.productCommercial": "Commercial",
  "menu.item.productPricing": "Price lists",
  "menu.item.productTaxes": "Taxes",
  "menu.section.productPartners": "Partners",
  "menu.item.productSuppliers": "Suppliers",
  "menu.item.productManufacturers": "Manufacturers",
  "menu.section.productData": "Data",
  "menu.item.productImports": "Import",
  "menu.item.productExports": "Export",
  "menu.item.productSearch": "Search",
  "menu.section.productIntegrations": "Integrations",
  "menu.item.productApiKeys": "API keys",
  "menu.item.productWebhooks": "Webhooks",
  "menu.section.productAdmin": "Administration",
  "menu.item.productNotifications": "Notifications",
  "menu.item.productRevisions": "Revisions",
  "menu.item.productClassification": "AI classification",
  "menu.item.productDedup": "Deduplication",
  "menu.item.productSettings": "Settings",
  "menu.item.securitySection": "Security",
  "menu.item.securityDashboard": "Overview",
  "menu.item.securityAgents": "Agents",
  "menu.item.securityGrades": "Grades",
  "menu.item.securityDocuments": "Documents",
  "menu.item.securityCertifications": "Certifications",
  "menu.item.securitySettings": "Settings",
  "menu.section.securityOperations": "Operations",
  "menu.section.securityWorkforce": "Workforce",
  "menu.section.securityAttendance": "Field attendance",
  "menu.section.securityPatrols": "Patrols",
  "menu.section.securityIncidents": "Incidents",
  "menu.section.securityLogbook": "Logbook",
  "menu.section.securityAccess": "Access control",
  "menu.section.securityEquipment": "Equipment",
  "menu.section.securityAdmin": "Administration",
  "menu.item.securityClients": "Clients",
  "menu.item.securitySites": "Sites",
  "menu.item.securityPosts": "Posts",
  "menu.item.securityAssignments": "Assignments",
  "menu.item.securityShifts": "Shifts",
  "menu.item.securityQualifications": "Qualifications",
  "menu.item.securityCheckIn": "Check-in",
  "menu.item.securityCheckOut": "Check-out",
  "menu.item.securityPresence": "Presence",
  "menu.item.securityPatrolRoutes": "Routes",
  "menu.item.securityCheckpoints": "Checkpoints",
  "menu.item.securityPatrolExecutions": "Executions",
  "menu.item.securityIncidents": "Incidents",
  "menu.item.securityInvestigations": "Investigations",
  "menu.item.securityIncidentActions": "Actions",
  "menu.item.securityLogEntries": "Entries",
  "menu.item.securityLogEvents": "Events",
  "menu.item.securityLogObservations": "Observations",
  "menu.item.securityVisitors": "Visitors",
  "menu.item.securityVehicles": "Vehicles",
  "menu.item.securityPasses": "Passes",
  "menu.item.securityEquipmentAssignments": "Assignments",
  "menu.item.securityWeapons": "Weapons",
  "menu.item.securityRadios": "Radios",
  "menu.item.securityUniforms": "Uniforms",
  "menu.item.securityWorkflows": "Workflows",
  "menu.item.securityReports": "Reports",
  "menu.item.itsmSection": "ITSM",
  "menu.item.itsmDashboard": "Overview",
  "menu.item.itsmTickets": "Tickets",
  "menu.item.itsmIncidents": "Incidents",
  "menu.item.itsmSla": "SLA",
  "menu.item.itsmTechnicians": "Technicians",
  "menu.item.mspSection": "MSP Operations",
  "menu.item.mspDashboard": "Overview",
  "menu.item.mspProblems": "Problems",
  "menu.item.mspChanges": "Changes",
  "menu.item.mspProjects": "Projects",
  "menu.item.mspKnowledge": "Knowledge Base",
  "menu.item.contractsSection": "MSP Commercial",
  "menu.item.contractsDashboard": "Overview",
  "menu.item.contractsCustomers": "Customers",
  "menu.item.contractsList": "Contracts",
  "menu.item.contractsServices": "Service Catalog",
  "menu.item.contractsBilling": "Billing",
  "menu.item.serviceDeliverySection": "Service Delivery",
  "menu.item.serviceDeliveryDashboard": "Dashboard",
  "menu.item.serviceDeliveryRequests": "Requests",
  "menu.item.serviceDeliveryApprovals": "Approvals",
  "menu.item.serviceDeliveryProvisioning": "Provisioning",
  "menu.item.serviceDeliveryAutomation": "Automation",
  "menu.item.serviceDeliveryTemplates": "Templates",
  "menu.item.leaves": "Leave",
  "menu.item.payslips": "Payslips",
  "menu.item.payrollRuns": "Payroll runs",
  "menu.item.payrollSection": "Payroll",
  "menu.item.jobs": "Job openings",
  "menu.item.candidates": "Candidates",
  "menu.item.contacts": "Contacts",
  "menu.item.companies": "Companies",
  "menu.item.deals": "Deals",
  "menu.item.leads": "Leads",
  "menu.item.tickets": "Tickets",
  "menu.item.knowledgebase": "Knowledge base",
  "menu.item.users": "Users",
  "menu.item.tenantUsers": "Users",
  "menu.item.roles": "Roles",
  "menu.item.tenantRoles": "Roles",
  "menu.item.tenantModuleAccess": "Module access",
  "menu.item.tenantSites": "Sites & stock",
  "menu.item.tenantProvisioning": "Provisioning",
  "menu.item.invitations": "Invitations",
  "menu.item.settings": "Settings",
  "menu.item.tenantCompanies": "Companies",
  "menu.item.subscriptions": "Subscriptions",
  "menu.item.domains": "Domains",
  "menu.item.clientTickets": "Client tickets",
  "menu.item.sla": "SLA",
  "menu.item.platformSettings": "Platform settings",
  "menu.item.packages": "Packages",
  "menu.item.languageFrench": "French",
  "menu.item.languageEnglish": "English",
  "common.searchInApp": "Search in {app}",
  "common.language.fr": "FR",
  "common.language.en": "EN",
};
